import type { IntegrationProviders } from '@vy/types';
import { useEffect } from 'react';
import type { QueryClient } from 'react-query';
import { useQueryClient } from 'react-query';
import { useActivatedIntegration } from '../../use-activated-integration';

export function useIntegrationPrefetch<PrefetchResult = unknown>(
  integrationProvider: IntegrationProviders,
  prefetchFunction: (queryClient: QueryClient) => Promise<PrefetchResult>,
  dependencies: unknown[] = []
) {
  const queryClient = useQueryClient();
  const isIntegrationEnabled = useActivatedIntegration(integrationProvider, { suspense: false });

  useEffect(() => {
    if (isIntegrationEnabled) {
      void prefetchFunction(queryClient);
    }
  }, [isIntegrationEnabled, queryClient, ...dependencies]);
}

